module.exports = __webpack_public_path__ + "img/leechbg.65dbebc2.png";